import { useSyncExternalStore } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export function PendingSyncIndicator() {
  const qc = useQueryClient();
  const { t } = useTranslation('common');

  // Subscribe to the mutation cache via useSyncExternalStore rather than
  // useEffect + setState. The mutation cache notifies subscribers synchronously
  // when a mutation is created mid-render (e.g. a dialog firing a mutation), so
  // a setState-based subscriber would update this component while another is
  // rendering ("Cannot update a component while rendering a different one").
  // useSyncExternalStore is built for exactly this; the snapshot is a primitive
  // count (stable by value), so there's no re-render loop.
  const count = useSyncExternalStore(
    (onChange) => qc.getMutationCache().subscribe(onChange),
    () => qc.getMutationCache().getAll().filter((m) => m.state.isPaused).length,
    () => 0,
  );

  if (count === 0) return null;

  return (
    <div data-testid="pending-sync" className="text-xs text-amber-300 px-3 py-0.5">
      {t('offline.pendingSync', { count })}
    </div>
  );
}
